(() => {
  const init = () => {
    const wishlist_popup = document.getElementById("popup-wishlist");
    const { customerId, customerName, customerWishlist, storefrontToken } =
      document.querySelector(".wishlist-embed").dataset;
    let wishlistItemsAdded = JSON.parse(localStorage.getItem("wishlistItems"));
    let wishlistShareUrl = document.querySelector(
      ".wishlist-share-url-container"
    );
    let wishlistShareUrlInput = document.querySelector(
      ".wishlist-share-url > input"
    );
    let btnWishlistShare = document.querySelector(
      ".wishlist-share-url > button"
    );
    let shareUrlDisplayState = false;
    let hDisplayShareLinkTime = 0;
    const baseUrl = location.origin + Shopify.routes.root;

    let wishlistItemHtmlCache = {};

    // const handleWishlistSave = async () => {
    //   document.querySelector(".btn-wishlist-save").classList.add("pending");
    //   const rawResponse = await fetch(
    //     "/customer-wishlist",
    //     {
    //       method: "POST",
    //       headers: {
    //         Accept: "application/json",
    //         "Content-Type": "application/json",
    //       },
    //       body: JSON.stringify({
    //         products: wishlistItemsAdded,
    //       }),
    //     }
    //   );
    //   document.querySelector(".btn-wishlist-save").classList.remove("pending");
    //   let success = false;
    //   if (rawResponse.ok) {
    //     const response = await rawResponse.json();
    //     success = response.success;
    //   }
    //   if (success) {
    //     const actionFeedback = document.querySelector(
    //       ".save-into-account .action-feedback_success"
    //     );
    //     actionFeedback.style.display = "inline";
    //     setTimeout(() => {
    //       actionFeedback.style.display = "none";
    //     }, 3000);
    //   } else {
    //     const actionFeedback = document.querySelector(
    //       ".save-into-account .action-feedback_fail"
    //     );
    //     actionFeedback.style.display = "inline";
    //     setTimeout(() => {
    //       actionFeedback.style.display = "none";
    //     }, 3000);
    //   }
    // };

    const handleWishlistShare = () => {
      const wishlistContent = {
        items: wishlistItemsAdded,
        name: customerName,
      };

      if (wishlistShareUrlInput && !shareUrlDisplayState) {
        shareUrlDisplayState = true;
        wishlistShareUrl.style.display = "block";
        hDisplayShareLinkTime = setTimeout(() => {
          wishlistShareUrl.style.display = "none";
          shareUrlDisplayState = false;
        }, 10000);
        wishlistShareUrlInput.value = `${baseUrl}?shared_wishlist=${btoa(
          JSON.stringify(wishlistContent)
        )}`;
      } else if (shareUrlDisplayState) {
        clearTimeout(hDisplayShareLinkTime);
        wishlistShareUrl.style.display = "none";
        shareUrlDisplayState = false;
      }
    };

    if (btnWishlistShare) {
      btnWishlistShare.addEventListener("click", () => {
        navigator.clipboard
          .writeText(wishlistShareUrlInput.value)
          .then(() => {
            btnWishlistShare.innerText = btnWishlistShare.dataset.copied;
            shareUrlDisplayState = false;
            clearTimeout(hDisplayShareLinkTime);
            hDisplayShareLinkTime = 0;
            setTimeout(() => {
              wishlistShareUrl.style.display = "none";
              btnWishlistShare.innerText = btnWishlistShare.dataset.copy;
            }, 2000);
          })
          .catch((err) => {
            console.log(err);
          });
      });
    }

    const handlePopupClose = function () {
      Array.from(document.querySelectorAll(".popup-wishlist .close")).forEach(
        function (el) {
          el.addEventListener("click", function (e) {
            e.preventDefault();
            e.target.closest(".popup-wishlist").classList.remove("shown");
          });
        }
      );
    };

    const toggleProduct = function (productId) {
      	wishlistItemsAdded = wishlistItemsAdded ? wishlistItemsAdded : [];

      	if (wishlistItemsAdded.includes(productId)) {
        	wishlistItemsAdded = wishlistItemsAdded.filter((e) => e !== productId);

			window.dataLayer.push({
				event: 'remove_from_wishlist',
				item_id: productId,
			});

	        updateWishlistButtons(productId, false);
      	} 
		else {
        	wishlistItemsAdded.push(productId);

			window.dataLayer.push({
				event: 'add_to_wishlist',
				item_id: productId,
			});

        	updateWishlistButtons(productId, true);
      	}

      	localStorage.setItem("wishlistItems", JSON.stringify(wishlistItemsAdded));
      	updateWishlistBadge();
    };

    const updateWishlistButtons = function (productId, added) {
      // When a product is added or removed from the compare list, update all checkboxes on the page that belong to this product.
      Array.from(
        document.querySelectorAll(
          `.wishlist-productcard[data-product-id="${productId}"], .wishlist-productpage > a[data-product-id="${productId}"]`
        )
      ).forEach(function (el) {
        if (added) {
          el.classList.add("active");
        } else {
          el.classList.remove("active");
        }
      });

      updateWishlistContent();
    };

    const showWishlistButtons = function () {
      const wishlistTrigger = document.querySelector(".wishlist-header");
      if (wishlistTrigger) {
        wishlistTrigger.classList.remove("hidden");
        wishlistTrigger.addEventListener("click", function (e) {
          e.preventDefault();
          const wishlistPopup = document.querySelector("#popup-wishlist");
          if (wishlistPopup) {
            displayWishlistItems();
            wishlistPopup.classList.add("shown");
          }
        });
      }
      const wishlistBtns = document.querySelectorAll(
        ".wishlist-productpage > a, .wishlist-productcard"
      );
      if (wishlistBtns?.length) {
        for (const wishlistButton of wishlistBtns) {
          wishlistButton
            .closest(".wishlist-productpage, .wishlist-productcard")
            .classList.remove("hidden");
          wishlistButton.addEventListener("click", function (e) {
            e.preventDefault();
            toggleProduct(wishlistButton.dataset.productId);
          });
        }
      }

      // const saveButton = document.querySelector("button.btn-wishlist-save");
      // if (saveButton) {
      //   saveButton.addEventListener("click", handleWishlistSave);
      // }

      const shareButton = document.querySelector("button.btn-wishlist-share");
      if (shareButton) {
        shareButton.addEventListener("click", handleWishlistShare);
      }
    };

    const loadWishlist = function () {
      wishlistItemsAdded = wishlistItemsAdded ? wishlistItemsAdded : [];
      if (
        customerWishlist &&
        localStorage.getItem("accountLoaded") !== customerId
      ) {
        const customerWishlistItems = customerWishlist.split(",");
        for (const customerWishlistItem of customerWishlistItems) {
          if (!wishlistItemsAdded.includes(customerWishlistItem)) {
            wishlistItemsAdded.push(customerWishlistItem);
          }
        }
        localStorage.setItem("accountLoaded", customerId);
      }
      if (wishlistItemsAdded?.length) {
        for (const item of wishlistItemsAdded) {
          updateWishlistButtons(item, true);
        }
      }

      localStorage.setItem("wishlistItems", JSON.stringify(wishlistItemsAdded));
      updateWishlistContent();
      updateWishlistBadge();
    };

    const handleRemoveButtons = function () {
      Array.from(document.querySelectorAll("#popup-wishlist .remove")).forEach(
        function (el) {
          el.addEventListener("click", function (e) {
            e.preventDefault();
            toggleProduct(el.dataset.productId);
          });
        }
      );
    };

    const displayWishlistItems = () => {
      let popupWishlistHtml = "";
      for (const item of wishlistItemsAdded) {
        const result = wishlistItemHtmlCache[item];

        if (!result) {
          continue;
        }
        
        const url = `${baseUrl}products/${result.data.product.handle}`;
        const productPrice = parseFloat(
          result.data.product.priceRange.minVariantPrice.amount
        );
        const productItemHtml = `<div class="product-wishlist-item">
                    <a href="${url}">
                        <picture class="product-image img-multiply-bg">
                            <img src="${
                              result.data.product.featuredImage.url
                            }" alt="product image"> 
                        </picture>
                    </a>
                    <a href="${url}">
                        <div class="ff-primary product-title">${
                          result.data.product.title
                        }</div>
                    </a>
                    <div class="ff-primary product-price">${Shopify.formatMoney(
                      productPrice * 100
                    )}</div>
                    <a href="#" class="remove" data-product-id="${result.data.product.id
                      .split("/")
                      .pop()}">
                        <i aria-hidden="true" class="icon-x-circle"></i>
                        <span class="hidden">Remove</span>
                    </a>
                </div>`;
        popupWishlistHtml = `${popupWishlistHtml}${productItemHtml}`;
      }
      document.querySelector("#popup-wishlist .products-wrapper").innerHTML =
        popupWishlistHtml;
      handleRemoveButtons();
      updateWishlistBadge();
    };

    const updateWishlistContent = async function () {
      if (!wishlistItemsAdded?.length) {
        wishlist_popup.classList.add("empty");
        return;
      }

      wishlist_popup.classList.remove("empty");
      for (const item of wishlistItemsAdded) {
        await getProductDetails(item);
      }
      const wishlistPopup = document.querySelector("#popup-wishlist");
      if (wishlistPopup && wishlistPopup.classList.contains("shown")) {
        displayWishlistItems();
      }
    };

    const updateWishlistBadge = () => {
      const badge = document.getElementById("wishlist-count");
      const wrapper = document.querySelector(".wishlist-header");

      if (!badge || !wrapper) return;

      const count = wishlistItemsAdded?.length || 0;

      if (count > 0) {
        badge.textContent = count;
        badge.style.display = "inline-block";
      } else {
        badge.style.display = "none";
      }
    };

    const loadSharedWishlist = async () => {
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      const wishlistInfo = urlParams.get("shared_wishlist");

      if (!wishlistInfo) {
        return;
      }

      const sharedWishlist = JSON.parse(atob(wishlistInfo));

      if (!sharedWishlist?.items?.length) {
        return;
      }

      let sharedWishlistHtml = "";
      for (const item of sharedWishlist.items) {
        const result = await getProductDetails(item);

        if (!result) {
          continue;
        }

        const url = `${baseUrl}products/${result.data.product.handle}`;
        let productPrice = parseFloat(
          result.data.product.priceRange.minVariantPrice.amount
        );
        const productItemHtml = `<div class="product-wishlist-item">
                        <a href="${url}">
                            <picture class="product-image img-multiply-bg">
                                <img src="${
                                  result.data.product.featuredImage.url
                                }" alt="product image">
                            </picture>
                        </a>
                        <a href="${url}">
                            <div class="ff-primary product-title">${
                              result.data.product.title
                            }</div>
                        </a>
                        <div class="ff-primary product-price">${Shopify.formatMoney(
                          productPrice * 100
                        )}</div>
                    </div>`;
        sharedWishlistHtml = `${sharedWishlistHtml}${productItemHtml}`;
      }
      document.querySelector("#shared-wishlist .products-wrapper").innerHTML =
        sharedWishlistHtml;
      // document.querySelector(".shared-wishlist-title").innerHTML =
      //   sharedWishlist.name;
      document.querySelector("#shared-wishlist").classList.add("shown");
    };

    const getProductDetails = async (productId) => {
      if (wishlistItemHtmlCache.hasOwnProperty(productId)) {
        return wishlistItemHtmlCache[productId];
      }

      const response = await fetch("/api/2025-07/graphql.json", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token": storefrontToken,
        },
        body: JSON.stringify({
          variables: {
            id: `gid://shopify/Product/${productId}`,
            language: Shopify.locale.toUpperCase(),
            country: Shopify.country.toUpperCase(),
          },
          query: `query productDetails($id: ID!, $language: LanguageCode!, $country: CountryCode!) @inContext(language: $language, country: $country) {
                        product(id: $id) {
                            id
                            title
                            handle
                            featuredImage {
                                url
                            }
                            priceRange {
                                minVariantPrice {
                                    amount
                                }
                            }
                        }
                    }`,
        }),
      });

      if (response.ok) {
        const result = await response.json();

        wishlistItemHtmlCache[productId] = result;

        return result;
      }

      return null;
    };

    showWishlistButtons();
    loadWishlist();
    handlePopupClose();
    loadSharedWishlist();
  };

  document.addEventListener("shopify:section:load", (e) => {
    if (e.srcElement.querySelector(".wishlist-productpage")) {
      init();
    }
  });

  init();
})();
